import React from 'react';
import { hssColors } from '../config/theme';

const Footer = () => (
  <div style={{
    background: hssColors.backgroundSecondary,
    borderTop: `1px solid ${hssColors.gray200}`,
    padding: '20px 24px',
    marginTop: 'auto',
  }}>
    <div style={{
      maxWidth: '1400px',
      margin: '0 auto',
      textAlign: 'center',
      color: hssColors.textSecondary,
      fontSize: '13px',
    }}>
      <p style={{ margin: '0 0 4px 0', fontWeight: '500' }}>
        © 2026 Hunter Security Systems S.A. · Sistema de Gestión
      </p>
      <p style={{ margin: 0, fontSize: '12px', opacity: 0.75 }}>
        Desarrollado por Ing. Rodrigo Melgarejo
      </p>
    </div>
  </div>
);

export default Footer;
